import {
    GENERAL_AUDIT_LOGS_OPEN_MODAL,
    GENERAL_AUDIT_LOGS_SEARCH_REQUEST,
    GENERAL_AUDIT_LOGS_SEARCH_RESULT,
    GENERAL_AUDIT_LOGS_SEARCH_MODULES_REQUEST,
    GENERAL_AUDIT_LOGS_SEARCH_MODULES_RESULT,
} from 'Redux/actionTypes';

export const generalAuditLogsOpenModal = (open, entityName, entityId, companyId, id, date, changes, action, method) => ({
    type: GENERAL_AUDIT_LOGS_OPEN_MODAL,
    payload: { open, entityName, entityId, companyId, id, date, changes, action, method }
})

export const generalAuditLogsSearchRequest = (filters) => ({
    type: GENERAL_AUDIT_LOGS_SEARCH_REQUEST,
    payload: { filters }
})

export const generalAuditLogsSearchResult = (result) => ({
    type: GENERAL_AUDIT_LOGS_SEARCH_RESULT,
    payload: { result }
})

export const generalAuditLogsSearchModulesRequest = (filters) => ({
    type: GENERAL_AUDIT_LOGS_SEARCH_MODULES_REQUEST,
    payload: { filters }
})

export const generalAuditLogsSearchModulesResult = (data) => ({
    type: GENERAL_AUDIT_LOGS_SEARCH_MODULES_RESULT,
    payload: data
})